import { injectStores } from "@intrasync/react";
import type { ScheduleGridHeaderCellProps } from "@intrasync/react";
import { RootStore, RouterStore, ServiceStore } from "@intrasync/stores";

interface ProductionScheduleRightHeaderCellProps
  extends ScheduleGridHeaderCellProps {
  currentHeader: {
    key: string | number;
    title: string;
  };
  routerStore?: RouterStore;
  jobStore?: ServiceStore;
  rootStore?: RootStore;
}

// interface CurrentClient {
//   shortName: string;
//   name: string;
// }

const ProductionScheduleRightHeaderCell = injectStores(
  (props: ProductionScheduleRightHeaderCellProps) => {
    const routerStore = props.routerStore;
    // const jobStore = props.rootStore.jobStore as ServiceStore;
    console.log("props", props);
    const { currentHeader } = props;

    // if (!jobStore.entities) {
    return (
      <div
        style={{
          border: "1px solid #eee",
          ...props.style,
          ...props.styles,
          display: "flex",
          flexDirection: "row",
        }}
      >
        <b
          style={{ cursor: "pointer" }}
          onClick={() => {
            routerStore.goTo("JobDashboard", {
              jobNumber: currentHeader.key,
            });
            console.log("clicked");
          }}
        >
          Station: {currentHeader?.title}
        </b>
      </div>
    );
    // }
    // const currentClient = jobStore.entities.find(
    //   (i) => i.jobNumber === currentHeader.key
    // ) as unknown as CurrentClient;
    // console.log('currentClient', currentClient);
    // return (
    //   <div
    //     style={{
    //       border: '1px solid #eee',
    //       ...props.style,
    //       ...props.styles,
    //       display: 'flex',
    //       flexDirection: 'row',
    //     }}
    //   >
    //     <Tooltip title="Navigate to Job Dashboard">
    //       <b
    //         style={{ cursor: 'pointer' }}
    //         onClick={() => {
    //           routerStore.goTo('JobDashboard', {
    //             jobNumber: currentHeader.key,
    //           });
    //           console.log('clicked');
    //         }}
    //       >
    //         {currentClient?.shortName
    //           ? currentClient.shortName
    //           : currentClient.name}
    //       </b>
    //     </Tooltip>
    //   </div>
    // );
  }
);

export default ProductionScheduleRightHeaderCell;
